import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Translate } from '../../../shared/LanguageService';
import { FeatureFlagKeys } from '../../../shared/featureFlags/featureFlagKeys';
import { useFeatureFlag } from '../../../shared/featureFlags/useFeatureFlag';
import { CloneOrderFlow } from './CloneOrderFlow';

interface IProps {
    orderId: number;
}

export const CloneOrderButton = (props: IProps) => {
    const isCloneOrderEnabled = useFeatureFlag(FeatureFlagKeys.CloneOrder, false);
    const [showModal, setShowModal] = React.useState(false);

    if (!isCloneOrderEnabled) {
        return null;
    }

    return (
        <>
            <Tooltip title={Translate('view-order/header/clone-order')}>
                <IconButton
                    aria-label={Translate('view-order/header/clone-order')}
                    onClick={() => setShowModal(true)}
                >
                    <ContentCopyIcon />
                </IconButton>
            </Tooltip>

            <CloneOrderFlow
                orderId={props.orderId}
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    );
};
